import { render, staticRenderFns } from "./CertifikatKategorija.vue?vue&type=template&id=02322227&scoped=true&"
import script from "./CertifikatKategorija.vue?vue&type=script&lang=js&"
export * from "./CertifikatKategorija.vue?vue&type=script&lang=js&"
import style0 from "./CertifikatKategorija.vue?vue&type=style&index=0&id=02322227&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02322227",
  null
  
)

export default component.exports